import { lazy } from 'react';
const routes = [
  {
		path: '/home',
		title: '首页',
		showTabBar: true,
		component: lazy(() => import('../views/Home'))
	},
  {
		path: '/details/:id?',
		title: '详情页',
		showTabBar: true,
		component: lazy(() => import('../views/Details'))
	}
];
export default routes;
